<template>
  <div v-if="$store.state.menu.Orders">
    <v-container fill-height fluid grid-list-xl>
      <Loader :loading="loading" />
      <v-layout justify-center wrap>
        <v-flex md12>
          <material-card color="green" title="Список заказов" text="Все заказы">
            <v-btn color="primary" @click="getOrders(false)" text>
              Обновить
            </v-btn>
            <div class="mt-2">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Поиск..."
                class="sticky search"
                :loading="loadingSearch"
                single-line
                hide-details
                clearable="true"
              ></v-text-field>
            </div>
            <v-data-table :headers="headers" :items="ordersList" hide-actions>
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template slot="items" slot-scope="{ item }">
                <td class="text-xs-left">CS-{{ item.id }}</td>
                <td class="text-xs-left min-width">{{ item.dealer.title }}</td>
                <td @click="SET_USER(item.dealer_id)" class="text-xs-left">
                  <span class="user-link">{{ item.dealer.phone_number }}</span>
                </td>
                <td class="text-xs-left">
                  {{ item.total | numberWithSpaces }}
                </td>
                <td class="text-xs-left">
                  <span class="text-warning" v-if="item.status === 1"
                    >Новый</span
                  >
                  <span class="text-primary" v-else-if="item.status === 2"
                    >Выполнен</span
                  >
                  <span class="error--text" v-else-if="item.status === 3"
                    >Отменен</span
                  >
                </td>
                <td class="text-xs-left">{{ item.created_at | dateTime }}</td>
                <td class="text-xs-right">
                  <v-icon @click="openPurchase(item.id)">mdi-pencil</v-icon>
                </td>
              </template>
            </v-data-table>

            <v-pagination
              v-if="last_page > 1"
              v-model="page"
              class="my-4"
              :length="last_page"
            ></v-pagination>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog width="800" v-if="currentOrder" v-model="currentOrder">
      <Purchases :setOrders="setOrders" :currentOrder="currentOrder" />
    </v-dialog>

    <Dealer />
  </div>
</template>

<script>
import Loader from "../components/helper/Loader";
import Dealer from "../components/core/Dealer";
import Purchases from "../components/core/Orders/Purchases";
import { mapMutations } from "vuex";

export default {
  data: () => ({
    page: 1,

    searcher: null,
    loadingSearch: true,

    loading: true,
    last_page: 0,
    search: "",
    headers: [
      {
        sortable: false,
        text: "№ заказа",
        value: "id",
      },
      {
        sortable: false,
        text: "Дилер",
        value: "dealer.title",
      },
      {
        sortable: false,
        text: "Номер телефона",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "Итоговая цена",
        value: "total",
      },

      {
        sortable: false,
        text: "Статус",
        value: "total",
      },
      {
        sortable: false,
        text: "Дата заказа",
        value: "created_at",
      },
      {
        sortable: false,
        text: "",
        value: "",
        align: "right",
      },
    ],
    ordersList: [],
    orderID: null,
    currentOrder: null,
  }),
  components: { Purchases, Loader, Dealer },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ORDERS"]),
    setOrders(val) {
      if (val) {
        this.getOrders();
      }
    },
    getOrders(noLoading) {
      if (!noLoading) this.loading = true;

      axios
        .get("admin/orders", {
          params: {
            per_page: 15,
            page: this.page,
            search: this.search,
          },
        })
        .then((response) => {
          this.SET_BADGE_ORDERS(0);
          this.ordersList = response.data.data;
          this.last_page = response.data.last_page;
          this.loading = false;
          this.currentOrder = null;
        })
        .catch((error) => {})
        .finally(() => {
          this.loadingSearch = false;
        });
    },
    openPurchase(orderID) {
      this.orderID = orderID;
      this.currentOrder = this.ordersList.filter(
        (x) => x.id == this.orderID
      )[0];
    },
  },

  watch: {
    search() {
      // this.loadingSearch = true;
      // this.page = 1;
      // setTimeout(() => {
      //     this.getOrders(true);
      // }, 300);
      //
      // this.loadingSearch = true;

      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getOrders(true);
      }, 1000);
    },
    page() {
      setTimeout(() => {
        this.getOrders();
      }, 300);
    },
  },
  mounted() {
    this.getOrders();
  },
};
</script>
